import React, { useState } from 'react';
import MessageList from './MessageList.js'; // Assuming this is an imported component
import {word} from '../../word.js'
import {useSelector} from "react-redux";
import Api from '../../Api.js'
const MessageInput = ({ visibleMessage, form}) => {
    const manager = useSelector((state) => state.manager.employee);
    const [message,setMessage] = useState([]);
    const [text, setText] = useState('');
    const [sendMessage, setSendMessage] = useState(false);
    const [forAll, setForAll] = useState(false);
    const [file, setFile] = useState('');
    const [filePreviewUrl, setFilePreviewUrl] = useState('');
    const handleTaskSms =async () => {
       try {
           if (text === '' && !file) return;
           const profession = localStorage.getItem("profession");
           const formData = new FormData();
           formData.append("text", text);
           formData.append("file", file);
           formData.append(profession, manager.url);
           formData.append("task", form?.url);
           formData.append("for_all", forAll);

           setSendMessage(true);
           await Api.sendMessage(formData)
           const {data} = await Api.getMessage(form?.id,{
               start_index: 0,
               for_all: null,
           })
           setMessage(data);
           setSendMessage(false);
           setText('');
           setFile('');
       }catch (e) {
           setSendMessage(false);

       }

    };

    const keyPress = async (e) => {
        // Your key press handling logic
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (!sendMessage) {
                await handleTaskSms();
            }
        }
    };


    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (!selectedFile) return;

        if (selectedFile.size === 0) {
            alert("Ֆայլը դատարկ է");
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            setFile(selectedFile);
            setFilePreviewUrl(reader.result);
        };
        reader.readAsDataURL(selectedFile);
    };

    return (
        <div className="message-list-inputs">
            {visibleMessage && <MessageList task={form} setMessage={setMessage} message={message}/>}
            {visibleMessage && (
                <div className="send-message">
                    <div className='input-image'>
                        <div>{filePreviewUrl && <img src={filePreviewUrl} alt="Preview" />}</div>
                        <div className="send-file">
                            <textarea
                                className='area'
                                readOnly={sendMessage}
                                onKeyDown={keyPress}
                                name="text"
                                autoFocus
                                placeholder={word.enter_message}
                                value={text}
                                onChange={(e) => setText(e.target.value)}
                            />
                            <div className='message-icons'>
                                <label className="checkbox-cont">
                                    <div className="title">բոլորի համար</div>
                                    <div className="cont">
                                        <input
                                            checked={forAll}
                                            onChange={() => setForAll(!forAll)}
                                            type="checkbox"
                                        />
                                        <span className="checkmark"/>
                                    </div>
                                </label>
                                <label>
                                    <i className="fas fa-image"/>
                                    <input
                                        type="file"
                                        className='input-icon'
                                        onChange={handleFileChange}
                                    />
                                </label>
                                <i
                                    onClick={async () => {
                                        if (!sendMessage) await handleTaskSms();
                                    }}
                                    className="fa fa-paper-plane"
                                    aria-hidden="true"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MessageInput;
